export default function NoPermission() {
  return (
    <div style={{ padding: "2rem", textAlign: "center", width: "100%" }}>
      <h2>Access Denied</h2>
      <p>You do not have permission to view this content.</p>
    </div>
  );
}
